import React from 'react';
import { CheckIcon } from 'lucide-react';
import { images, offerIncludes } from '../data/content';
import { SectionHeading } from './SectionHeading';
import { Price } from './Price';
export function OfferStack() {
  return <section id="offer" className="bg-cream py-14 lg:py-24" data-id="element-127" data-mp="2ptvcdgkewsi6">
      <div className="mx-auto max-w-content px-5 sm:px-8" data-id="element-128" data-mp="2kwbn7lm6evbg">
        <SectionHeading title="Get the Complete Worry-to-Brave Toolkit Today" data-id="element-129" data-mp="2kwv2svoct7mb" />

        <div className="mt-8 grid items-center gap-8 lg:mt-12 lg:grid-cols-[minmax(0,1.1fr)_minmax(0,0.9fr)] lg:gap-14" data-id="element-130" data-mp="1x7ahw78n40ae">
          <img src={images.offerBundle} alt="Everything inside The Worry-to-Brave Toolkit: six volumes and five bonuses" loading="lazy" className="-mx-2 w-[calc(100%+1rem)] max-w-[640px] sm:mx-auto sm:w-full" data-id="element-131" data-mp="1t2t2ek9bc95f" />

          <div data-id="element-132" data-mp="1eeoso5s8n7ys">
            <div className="rounded-[28px] bg-paper p-6 shadow-sheet sm:p-10" data-id="element-133" data-mp="1ee6o8lvf9nfs">
              <p className="font-display text-[21px] uppercase tracking-[0.05em] text-ink" data-id="element-134" data-mp="19g55k21wrq4u">The Worry-to-Brave Toolkit</p>
              <ul className="mt-5 grid gap-2.5 sm:grid-cols-2 lg:grid-cols-1" data-id="element-135" data-mp="14otkw3n1t6c6">
                {offerIncludes.map(item => <li key={item} className="flex items-center gap-3 text-[15px] text-ink sm:text-[16px]" data-id="element-136" data-mp="1eewmutc5dumn">
                    <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-sage-wash text-sage-deep" data-id="element-137" data-mp="1jdq2osewpxpz">
                      <CheckIcon className="h-3.5 w-3.5" strokeWidth={3} aria-hidden="true" data-id="element-138" data-mp="lr983uxk5y7x" />
                    </span>
                    {item}
                  </li>)}
              </ul>
              <div className="my-7 border-t border-dashed border-cream-line" data-id="element-139" data-mp="vncb1308i0vx" />
              <Price data-id="element-140" data-mp="zqiddzk877x4" />
            </div>

            <div className="mt-4 flex items-center gap-4 rounded-2xl border border-sage/70 bg-sage-wash p-5" data-id="element-141" data-mp="zrblp4yu25hd">
              <div className="flex h-16 w-16 shrink-0 flex-col items-center justify-center rounded-full border border-dashed border-sage-deep/60 bg-paper" aria-hidden="true" data-id="element-142" data-mp="275n2tm8zv1b9">
                <span className="font-display text-[28px] leading-none text-ink" data-id="element-143" data-mp="71b2tekwp5nl">7</span>
                <span className="text-[8px] font-bold uppercase tracking-[0.14em] text-sage-deep" data-id="element-144" data-mp="73nfpdbt4pts">Days</span>
              </div>
              <div data-id="element-145" data-mp="g1hf4x4vbzl6">
                <p className="font-display text-[20px] leading-tight text-ink" data-id="element-146" data-mp="g324m8cbssc6">7-Day Guarantee</p>
                <p className="mt-1 text-[14px] leading-snug text-ink-soft" data-id="element-147" data-mp="3oiu9kvxdva0u">
                  Explore the toolkit for 7 days and see how the resources fit your family’s needs. Your purchase is protected by our
                  7-Day Guarantee.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}